import React from "react"

import SEO from "../components/seo"
import Header from "../components/Header"
import Arrow from './../images/icons/drop-down.png'
import Faq from './../images/faq.jpg'
import Footer from '../components/Footer'
import Expandable from '../components/Expandable'
import ScrollSpy from './../components/ScrollSpy'

export default () => {

  const list1 = [
    { title: 'آیا اطلاعات وبگاه و نرم افزار دیجی مالیات به روز است ؟', text: 'بله- اطلاعات قوانین و مقررات هر روز توسط کارشناسان مالی و مالیاتی دیجی مالیات درج و ثبت و به روز رسانی میگردد.' },
    { title: 'آیا دیجی مالیات فقط از طریق سایت قابل دسترسی هست ؟', text: 'خیر – شما می توانید از طریق نرم افزار های گوشی همراه اندرویدی(Android) و آی او اس (IOS) نیز دسترسی داشته باشید' },
  ]
  const list2 = [
    { title: 'آیا جهت دسترسی به قوانین ومقررات دیجی مالیات حتمی باید عضو دیجی مالیات شد؟', text: 'خیر- برای مشاهده قوانین و مقررات در دیجی مالیات نیازی به عضویت در دیجی مالیات نمی باشد.' },
    { title: 'در چه صورت باید عضو دیجی مالیات شد؟', text: 'تنها درصورتی که بخواهیم از سایر دسترسی های سامانه دیجی مالیات  مانند کتابخانه شخصی ، هم اندیشی ، فعالیت های مالیاتی، یادداشت شخصی، فایل های آموزشی  و آزمون ها بهرمند گردیدم نیازمند به عضویت در دیجی مالیات می باشد.' },
    { title: 'آیا عضویت در دیجی مالیات دارای هزینه می باشد؟', text: 'خیر- عضویت در دیجی مالیات شامل هیچ هزینه ای نمی باشد' },
  ]
  const list3 = [
    { title: 'کتابخانه شخصی چیست؟', text: 'در این بخش شما می توانید هر ماده قانونی یا بخشنامه ای که مورد علاقه تان باشد را در طبقه بندی های دلخواهتان الصاق و با مراجعه به طبقه بندی های هر موضوع به آن مواد و بخشنامه دسترسی آنی پیدا نمایید.' },
    { title: 'آیا می توان یک ماده یا بخشنامه را به چندین طبقه بندی الصاق نمود؟', text: 'بله می توان هر ماده یا بخشنامه را به هر طبقه دلخواه الصاق یا جدا نمود.' },
    { title: 'منظور از یادداشت شخصی چیست؟', text: 'منظور از یادداشت شخصی همان درج اطلاعات متنی در خصوص مواد قانونی یا بخشنامه ها می باشد که در زمان مطالعه آنها می توان به صورت نکات برچسته یا پرسش و پاسخ های شخصی از آن در هر زمان بهره برد.' },
    { title: 'آیا یادداشت شخصی امن است و می توان با نام کاربری برای همیشه از آن بهره برد؟', text: 'بله- تمامی یادداشت های شخصی کاربران رمزنگاری شده و تنها کاربر به آن دسترسی دائمی دارد.' },
  ]
  const list4 = [
    { title: 'منظور از هم اندیشی چیست؟', text: 'منظور از هم اندیشی آنست که کاربران می توانند از هر ماده یا بخشنامه سوال نموده و پس از بررسی سوال مربوطه توسط کارشناسان دیجی مالیات سوال در سامانه برای همگان قابل مشاهده میگردد و می توانند اظهار نظر نمایند و  درصورتی که پاسخ های ارائه شده مناسب و مطلوب پرسش صورت گرفته باشد برای همه کاربران قابل مشاهده میگردد.' },
    { title: 'فایل آموزشی دیجی مالیات چه می باشند؟', text: 'فایل های آموزشی دیجی مالیات فایل های متنی و تصویری می باشند که کابران می توانند با داشتن نام کاربری رمزعبور به آنها دسترسی دارند.' },
    { title: 'آزمون های دیجی مالیات چیست؟', text: 'در این بخش انواع آزمون های مهم مالی و مالیاتی سازمان ها ، انجمن ها و جوامع مختلف مالی و مالیاتی بصورت هوشمند قرارداده شده و کاربران با انتخاب آزمون مورد نظر خود حسب زمان بندی مشخص شده می توانند نسبت به سنجش میزان دانش مالی و مالیاتی خود اقدام نمایند. کلیه آزمون ها دارای کلید و پاسخ تشریحی می باشد.' },
  ]

  return (
    <div className="slideInTop">
      <SEO title="سوالات متداول" />
      <Header />
      <ScrollSpy />
      <div id="parrent" className="overflow-auto rtl">
        <div className="mx-auto" style={{ height: 'calc(100vh - var(--top-nav-height))' }}>
          <div className="px-64"
            style={{ height: 'calc(100vh - var(--top-nav-height))', backgroundAttachment: 'fixed', maxHeight: 700, backgroundImage: `url(${Faq})`, backgroundPosition: 'top', backgroundSize: 'cover' }}>
            <div className="absolute" style={{
              bottom: 0,
              right: 'calc(50% - 22px)'
            }}>
              <button className="bd-none bg-none icon-button notifyMe" style={{ filter: 'drop-shadow(0px -4px 0px #464953)' }}
                onClick={() => document.getElementById('content-holder').scrollIntoView({ behavior: 'smooth' })}>
                <span className="bg-bg icon-mask thumb blocked" style={{
                  WebkitMaskImage: `url(${Arrow})`,
                  WebkitMaskSize: 'contain'
                }} />
              </button>
            </div>
          </div>
          <div id="content-holder" className="container pt-64">
            <section className="px-64 pb-45">
              <div className="pb-45 text-center">
                <span className="font-14">سوالات متداول</span>
                <h3 className="text-shadow font-24" style={{ marginRight: -20 }}>
                  <img className="icon-sm ml-8" style={{ transform: 'rotate(90deg)' }} src={Arrow} alt="" />
                  به تمامی سوالات شما پاسخگوییم
                </h3>
              </div>

              <div className="grid mb-32" style={{ gridTemplateColumns: '1fr 5fr' }}>
                <div className="bg-tomato-lighter flexed fl-c">
                  <span className="text-tomato bold font-14 text-shadow-tomato">آپدیت نرم افزار</span>
                </div>
                <Expandable list={list1} />
              </div>

              <div className="grid mb-32" style={{ gridTemplateColumns: '1fr 5fr' }}>
                <div className="bg-tomato-lighter flexed fl-c">
                  <span className="text-tomato bold font-14 text-shadow-tomato">ثبت نام</span>
                </div>
                <Expandable list={list2} />
              </div>

              <div className="grid mb-32" style={{ gridTemplateColumns: '1fr 5fr' }}>
                <div className="bg-tomato-lighter flexed fl-c">
                  <span className="text-tomato bold font-14 text-shadow-tomato">کتابخانه</span>
                </div>
                <Expandable list={list3} />
              </div>

              <div className="grid" style={{ gridTemplateColumns: '1fr 5fr' }}>
                <div className="bg-tomato-lighter flexed fl-c">
                  <span className="text-tomato bold font-14 text-shadow-tomato">خدمات</span>
                </div>
                <Expandable list={list4} />
              </div>

            </section>
          </div>
          <Footer />
        </div>
      </div>
    </div >
  )
}
